import React from "react";
import { Box, Typography, Container, List, ListItem, Paper } from "@mui/material";
import { Helmet } from "react-helmet"; // Importing react-helmet
import { useTheme } from "@mui/material/styles";

const FAQs = () => {
  const theme = useTheme();

  const faqs = [
    {
      question: "What time are Sunday services?",
      answer: "Sunday services are held at 9:00 AM and 6:00 PM.",
    },
    {
      question: "How can I get involved?",
      answer: "Join one of our programs or volunteer for events.",
    },
    {
      question: "Where are you located?",
      answer: "We are located in Dharmapuri, Tamil Nadu, India.",
    },
    {
      question: "How can I donate to the church?",
      answer: "You can donate via bank transfer or online payment methods. Check the 'Get Involved' page for details.",
    },
    {
      question: "Do you offer youth programs?",
      answer: "Yes, we have a vibrant youth ministry and organize events throughout the year.",
    },
  ];

  return (
    <Box
      sx={{
        py: 5,
        backgroundColor: "background.default",
        animation: `${theme.keyframes.fadeIn} 1.5s`,
      }}
    >
      <Helmet>
        <title>FAQs | Praise Revival Church Dharmapuri</title>
      </Helmet>
      <Container>
        {/* Page Title */}
        <Typography
          variant="h2"
          gutterBottom
          align="center"
          sx={{
            fontWeight: "bold",
            color: "primary.main",
            animation: `${theme.keyframes.fadeInUp} 1.5s`,
          }}
        >
          Frequently Asked Questions
        </Typography>

        {/* FAQ List */}
        <List>
          {faqs.map((faq, index) => (
            <ListItem
              key={index}
              sx={{
                animation: `${theme.keyframes.fadeIn} 2s`,
                marginBottom: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                  transform: "scale(1.02)",
                  transition: "transform 0.2s ease-in-out",
                },
              }}
            >
              <Paper
                sx={{
                  width: "100%",
                  padding: 2,
                  boxShadow: theme.shadows[3],
                  borderRadius: 2,
                  backgroundColor: "background.paper",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "primary.main",
                    marginBottom: 1,
                  }}
                >
                  {faq.question}
                </Typography>
                <Typography variant="body1" sx={{ color: "text.primary" }}>
                  {faq.answer}
                </Typography>
              </Paper>
            </ListItem>
          ))}
        </List>
      </Container>
    </Box>
  );
};

export default FAQs;
